import React, { useMemo, useContext } from "react";
import { DataTableContext } from "../Tabs/Overview";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import { ViewMasterCampaignsContext } from "../index";
import { useCallback } from "react";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import { useNavigate } from "react-router-dom";
import { multipleMasterCampaignsSelected } from "./actionValidations";

export default () => {
	// Import various contexts
	const { checkboxSelections, dataProvider } = useContext(DataTableContext);
	const { enabledPlatformAPIs, platforms } = useContext(ViewMasterCampaignsContext);

	const shown = useMemo(() => {
		return (
			enabledPlatformAPIs?.find(({ MasterPlatformID, SyncStatus }) => {
				if (MasterPlatformID == 1 || MasterPlatformID == 5) {
					return SyncStatus;
				}
				return false;
			})?.SyncStatus || false
		);
	}, [enabledPlatformAPIs]);

	const disabled = useMemo(() => {
		if (shown) {
			const sac = checkboxSelections?.selectedActivationCampaigns;
			if (sac?.length == 1) {
				const platformId = platforms?.find(({ PlatformName }) => PlatformName == sac?.[0]?.platform)?.MasterPlatformID;
				if (platformId == 5) {
					return false;
				}
			}
		}
		return true;
	}, [shown, checkboxSelections, platforms]);

	const multipleMasterCampaigns = useMemo(() => multipleMasterCampaignsSelected(checkboxSelections), [checkboxSelections]);

	const navigate = useNavigate();

	const navigateToCrossPlatformQA = useCallback(() => {
		if (shown && !disabled) {
			const sac = checkboxSelections?.selectedActivationCampaigns;
			if (sac?.length == 1) {
				const campaign = sac?.[0] || "";

				const prismaEnabled = enabledPlatformAPIs?.find(({ MasterPlatformID }) => MasterPlatformID == 5)?.SyncStatus;
				const gcmEnabled = enabledPlatformAPIs?.find(({ MasterPlatformID }) => MasterPlatformID == 1)?.SyncStatus;

				// Gcm == 1; prisma == 5;
				let navWithPlatformId = null;
				if (prismaEnabled) {
					navWithPlatformId = 5;
				} else if (gcmEnabled) {
					navWithPlatformId = 1;
				}

				if (navWithPlatformId) {
					// prettier-ignore
					const {CampaignName_Friendly, HierarchyLevelID} = dataProvider.data
						?.find(({ CampaignID }) => CampaignID === campaign.masterCampaignId)
						?.ActivationCampaigns?.[campaign.platform]?.find(({ CampaignID }) => CampaignID == campaign.activationCampaignId)
                        || {};

					navigate(
						`/CrossPlatformQA/${campaign?.activationCampaignId}?campaignName=${CampaignName_Friendly}&masterCampaignId=${campaign?.masterCampaignId}&hierarchyLevelId=${HierarchyLevelID}`
					);
				}
			}
		}
	}, [checkboxSelections, platforms, enabledPlatformAPIs, dataProvider]);

	const Trigger = () => {
		if (shown) {
			return (
				<Tooltip title="Cross Platform QA" position={TOOLTIP_POSITION.BOTTOM}>
					<Button
						// This comment exists to prevent eslint from making this unreadable.
						display={BUTTON_DISPLAY.ICON_BORDERED}
						size={BUTTON_SIZE.SMALL}
						icon="icon-compare"
						onClick={navigateToCrossPlatformQA}
						disabled={disabled || multipleMasterCampaigns}
						id="crossPlatformQAButton"
						data-tracking-id-alt="cross-platform-qa-button"
					>
						Cross Platform QA
					</Button>
				</Tooltip>
			);
		}
		return <></>;
	};

	// Return a memoized object containing both of these components
	return useMemo(() => ({ Trigger }), [shown, disabled, checkboxSelections, platforms, enabledPlatformAPIs]);
};
